import PropTypes from "prop-types";
// form
import { FormProvider as Form } from "react-hook-form";
import "./form.css";
// ----------------------------------------------------------------------

FormProvider.propTypes = {
  children: PropTypes.node,
  methods: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default function FormProvider({ children, onSubmit, methods, style }) {
  return (
    <Form {...methods}>
      <form style={style} id="general-form" onSubmit={onSubmit}>
        {children}
      </form>
    </Form>
  );
}
